/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC } from "react";
import { Link } from "react-router-dom";
import { logoContainerCss, logoCss } from "./styles";

const Logo: FC = () => (
  <div css={logoContainerCss} id="flowio-logo-container">
    <Link to="/" css={logoCss} id="flowio-navbar-logo" />
  </div>
);

export default Logo;
